import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class AdditionalQuestionsService {

    private baseUrl = environment.apiBaseUrl;
    constructor(private http: HttpClient, private dataService: DataService) { }

    //getCustomerDocumentFileUploaderInstance --need to implement

    getUploadedDocuments(customerApplicationId: number) {
        return this.dataService.getRecord('/api/ApplicationDocumentMapping/getUploadedDocuments/' + customerApplicationId);
    };

    delteCustomerDocument(documentId: number) {
        //return this.dataService.post('/api/Login/Register', data)
        //return this.dataService.post('/api/ApplicationDocumentMapping/DeleteCustomerDocument/' + documentId);
    };

    downloadFile(documentId: number) {
        return this.dataService.getRecord('/api/ApplicationDocumentMapping/downloadfile/' + documentId);
    };

    getAdditionalQuestions(applicationId: number) {
        return this.dataService.getRecord('/api/Application/GetAdditionalQuestions/' + applicationId);
    }

    getISPAdditionalQuestionsToApprove(applicationId: number) {
        return this.dataService.getRecord('/api/Application/GetISPAdditionalQuestionsToApprove/' + applicationId);
    }

    notificationMailToISP(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/NotificationMessageInfo/NotificationMailToISP/' + applicationId);
    }

    getApplicationByAppId(applicationId: number) {
        return this.dataService.getRecord('/api/Application/GetApplicationByAppId/' + applicationId);
    }
    SaveAllExcelSheets(data: any) {
        return this.dataService.post('/api/Application/SaveAllExcelSheets/', data);
    }
}
